import { AbstractControl, ValidationErrors } from '@angular/forms';

export function atLeastOneDayValidator(control: AbstractControl): ValidationErrors | null {
  function getValue(name: string) {
    var c = control.get(name);
    return c ? c.value : false;
  }

  var days = [
    getValue('validOnSun'),
    getValue('validOnMon'),
    getValue('validOnTue'),
    getValue('validOnWed'),
    getValue('validOnThu'),
    getValue('validOnFri'),
    getValue('validOnSat')
  ];

  var hasOne = days.some(function(day) {
    return day === true;
  });

  return hasOne ? null : { atLeastOneDay: true };
}